import React, { useState } from "react";
import { Map } from "immutable";
import { Select, SelectOption, Separator } from "@showitinc/showit-wc";

import AppConstants from "../constants/AppConstants";
import LottieAssetSettings from "./elementproperties/LottieAssetSettings";
import LottieAssetLinkSettings from "./elementproperties/LottieAssetLinkSettings";
import { initFormatter } from "../utils/PropertyFormatters";
import CustomizeEffects from "../app2components/panel/shared/CustomizeEffects";
import InputComponent from "../app2components/base/Input";
import SplitMergeWrapper from "../app2components/base/SplitMergeWrapper";
import { COLOR_PICKER } from "../constants/InputConstants.mjs";

const {
  UPDATE_ACTION_SET,
  UPDATE_ACTION_DELETE,
  LOTTIE_TYPE_ASSET,
  LOTTIE_TYPE_ASSET_LINK,
  TRANSPARENT,
} = AppConstants;

const CONTENT_TYPE = "content.type";
const CONTENT_BG_COLOR = "content.backgroundColor";
const BG_COLOR_DEFAULT = "colors-4:100";

const ElementPropertiesLottie = ({
  element,
  elementId,
  isLocked,
  theme,
  onPropUpdate,
  mappedElement,
  layout,
}) => {
  const [showBgColor, setShowBgColor] = useState(false);

  const lottie = element.get("content", Map());
  const type = lottie.get("type");
  const bgColor = lottie.get("backgroundColor");
  const bgColorVisible = showBgColor || (bgColor && bgColor !== TRANSPARENT);

  const _onTypeChange = (propInfo) => {
    onPropUpdate({
      ...propInfo,
      action: UPDATE_ACTION_SET,
      name: "content",
      value: !propInfo.value ? {} : { type: propInfo.value, loop: 1, speed: 1 },
    });
  };

  const { onChange } = initFormatter(onPropUpdate);
  const { onChange: onTypeChange } = initFormatter(_onTypeChange);

  const addBgColor = () => {
    setShowBgColor(true);
    onPropUpdate({ name: CONTENT_BG_COLOR, value: BG_COLOR_DEFAULT, action: UPDATE_ACTION_SET });
  };

  const removeBgColor = () => {
    setShowBgColor(false);
    onPropUpdate({ name: CONTENT_BG_COLOR, action: UPDATE_ACTION_DELETE });
  };

  return (
    <>
      <Select
        data-testid="lottie-source-select"
        disabled={isLocked}
        label="Source"
        onSISelect={onTypeChange(CONTENT_TYPE, type)}
        reserveContext
        shift="left"
        value={type}
      >
        <SelectOption value={LOTTIE_TYPE_ASSET}>Media Library</SelectOption>
        <SelectOption value={LOTTIE_TYPE_ASSET_LINK}>Asset Link</SelectOption>
      </Select>

      {type === LOTTIE_TYPE_ASSET && (
        <LottieAssetSettings
          isLocked={isLocked}
          element={element}
          theme={theme}
          onPropChange={onPropUpdate}
        />
      )}
      {type === LOTTIE_TYPE_ASSET_LINK && (
        <LottieAssetLinkSettings
          isLocked={isLocked}
          element={element}
          elementId={elementId}
          layout={layout}
          onPropChange={onPropUpdate}
        />
      )}

      <CustomizeEffects
        mappedElement={mappedElement}
        layout={layout}
        onPropUpdate={onPropUpdate}
        preparedElement={element}
        extraMenuItems={bgColorVisible ? [] : [{ label: "BG Color", onClick: addBgColor }]}
      >
        {bgColorVisible && (
          <>
            <Separator />
            <SplitMergeWrapper sync canToggle={false} removeCustomization={removeBgColor}>
              <InputComponent
                context
                disabled={isLocked}
                label="BG Color"
                inputType={COLOR_PICKER}
                color={bgColor || TRANSPARENT}
                onSIBeforeChange={onChange(CONTENT_BG_COLOR, bgColor)}
                onSIChange={onChange(CONTENT_BG_COLOR, bgColor)}
                onSIInput={onChange(CONTENT_BG_COLOR, bgColor, false)}
              />
            </SplitMergeWrapper>
          </>
        )}
      </CustomizeEffects>
    </>
  );
};

export default ElementPropertiesLottie;
